<template>
  <div class="our_courses">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section_title text-center mb-100">
            <h3>课程特色</h3>
            <p>
              紧贴中国教育部2022-义务教育信息科技课程新课标，围绕义务教育阶段学生核心<br />
              素养发展，包括信息意识、计算思维、数字化学习与创新、信息社会责任。互相渗<br />
              透，共同促进学生数字素养与技能的提升。
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-md-6 col-lg-6">
          <div class="single_course text-center">
            <div class="icon">
              <i class="flaticon-art-and-design"></i>
            </div>
            <h3>科创兴趣发展</h3>
            <p>
              遵循学生身心发展阶段特征划分四个学段。结合现实世界真实问题为主题，创作作品，培养学生学习兴趣及良好的学习惯。
            </p>
          </div>
        </div>
        <div class="col-xl-3 col-md-6 col-lg-6">
          <div class="single_course text-center">
            <div class="icon blue">
              <i class="flaticon-business-and-finance"></i>
            </div>
            <h3>竞赛考级体系</h3>
            <p>
              遴选国内顶级赛事为目标，以中国教育部白名单赛事、中国计算机学会CSP/S/J及GESP等级考试体系为评价主线。
            </p>
          </div>
        </div>
        <div class="col-xl-3 col-md-6 col-lg-6">
          <div class="single_course text-center">
            <div class="icon">
              <i class="flaticon-premium"></i>
            </div>
            <h3>自然科学实践</h3>
            <p>
              强调“科学知识”+“技术实践”为课程设计核心理念。培养学生的动手观察能力，发展学生的批判性思维及综合素质。
            </p>
          </div>
        </div>
        <div class="col-xl-3 col-md-6 col-lg-6">
          <div class="single_course text-center">
            <div class="icon gradient">
              <i class="flaticon-crown"></i>
            </div>
            <h3>课后服务进校</h3>
            <p>
              在“双减”政策指导下，紧贴新课程标准，前沿信息化技术作支撑。服务国内中小学科创类课程、师资、技术等需求。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  setup() {},
});
</script>
